<template>
  <div>
    <div v-if="applicant_data">
      <div v-if="!is_submitted" class="relative is-flex">
        <div class="is-flex relative vetting_modal_content">
          <div dir="rtl">
            <div class="center_horizontal">
              <div class="is-flex is-align-items-center is-justify-content-space-between mb-3">
                <vetting-recipe-selector
                  v-if="questions_data.gender"
                  :applicant_id="applicant_data.resource_id"
                  :gender="questions_data.gender.text"
                  :certification_date="certificationDateFormat"
                  v-model="abstract">
                </vetting-recipe-selector>
              </div>
              <Abstract :applicantId="applicant_data.resource_id" v-model="abstract" :isEditable="true" />
            </div>
            <SkillsForm v-model="tags" :payload="{ data: applicant_data }" :internal_submit_button="true" @new-value="setTags"></SkillsForm>
            <div
              class="is-flex is-align-items-center is-justify-content-space-between"
              style="margin-top: 20px;"
            >
              <div class="is-flex is-align-items-center">
                <div>
                  <select dir="rtl" v-model="is_star">
                    <option :value="true">gold_star</option>
                    <option :value="false">purple_star</option>
                    <option value="null">empty_star</option>
                  </select>
                </div>
                <div class="horizontal_space"></div>
                <img :src="getSelectedIsStarImg" width="30px">
              </div>
              <checkbox v-model="is_watch">is_watch</checkbox>
            </div>
            <div class="center_horizontal" style="margin-top: 20px;">
              <p><b>internal notes</b></p>
              <textarea
                placeholder="..."
                class="relative vetting_modal_textarea"
                v-model="internal_notes"
              >
              </textarea>
            </div>
            <div dir="ltr" style="margin-top: 30px;">
              <Status :applicantId="applicant_data.resource_id" v-model="applicant_status" />
            </div>

            <div style="margin-top: 30px;">
              <p><b>status</b></p>
              <select dir="rtl" v-model="status">
                <option>active</option>
                <option>currently_irrelevant</option>
                <option>blocked</option>
                <option>pending</option>
                <option>test</option>
              </select>
            </div>
            <div style="margin-top: 20px;">
              <p><b>Message</b></p>
              <textarea
                placeholder="Message"
                v-model="message">
              </textarea>
            </div>
          </div>
          <div class="horizontal_space"></div>
          <div v-if="questions.length > 0" class="relative questions">
            <q-select
              v-if="questions_data.gender"
              :default_option_text="$settings.get({ path: 'vetting_modal' }).default_gender"
              @input="questionValueSelected"
              :question="questions_data.gender.question"
            ></q-select>
            <AttributeDisplay
              :value="applicant_data.certification_date"
              :displayValue="seniorityYears.toString()"
              :data="applicant_data"
              componentName="CrudCertificationDateSeniority"
              title="Certification Date"
              requestName="updateApplicant"
              requestValue="certification_date"
              type="radio-group"
              :beforeAction="certificationDateUpdate"
              horizantal
            />
            <div class="my-5">
              <checkbox v-model="eleven_months_alert" :checked="eleven_months_alert">11_months_alert</checkbox>
            </div>
            <q-select
              v-if="questions_data.vetted_by"
              :default_option_text="$utils.getOwner().name"
              @input="questionValueSelected"
              :question="questions_data.vetted_by.question"
            ></q-select>
            <q-select
              :class="{ error: !is_discrete_answered }"
              v-if="questions_data.is_discrete"
              :default_option_text="$utils.getOwner().name"
              @input="questionValueSelected"
              :question="questions_data.is_discrete.question"
            ></q-select>
            <div>
              <p><b>Salary Expectations</b></p>
              <input v-model="salary_expectations_comment" style="width: 180px;" class="outlined" placeholder='10,000 ש"ח'>
            </div>
            <div>
              <p><b>Job Description</b></p>
              <input v-model="job_description" style="width: 180px;" class="outlined">
            </div>
            <div>
              <p><b>Preferred Work Region</b></p>
              <input v-model="preferred_work_region" style="width: 180px;" class="outlined">
            </div>
            <q-select
              v-if="questions_data.is_senior"
              @input="questionValueSelected"
              :question="questions_data.is_senior.question"
            ></q-select>
            <q-select
              :class="{ error: !approve_email_truthy }"
              v-if="questions_data.approve_email"
              @input="questionValueSelected"
              :question="questions_data.approve_email.question"
            ></q-select>
            <q-select
              v-if="questions_data.arrived_through"
              @input="questionValueSelected"
              :question="questions_data.arrived_through.question"
            ></q-select>
            <div>
              <p><b>Referral Text</b></p>
              <input v-model="referral_text" style="width: 180px;" class="outlined" placeholder=''>
            </div>
            <q-select
              v-if="questions_data.elite"
              @input="questionValueSelected"
              :question="questions_data.elite.question"
            ></q-select>
            <q-select
              v-if="questions_data.skip_educations_filter"
              @input="questionValueSelected"
              :question="questions_data.skip_educations_filter.question"
            ></q-select>
            <q-select
              v-if="questions_data.skip_seniority_filter"
              @input="questionValueSelected"
              :question="questions_data.skip_seniority_filter.question"
            ></q-select>
            <q-select
              :class="{ error: (isJobTitleMandatory && !job_title_answered) }"
              v-if="questions_data.job_title"
              :use_server_default="true"
              @input="questionValueSelected"
              :question="questions_data.job_title.question"
            ></q-select>
          </div>
          <div class="modal_footer is-justify-content-space-between">
            <a
              @click="preSubmit()"
              :class="{ 'is-loading': is_loading, faded: !isSubmitButtonEnabled }"
              class="button is-info"
              >Submit</a
            >
            <div class="is-flex absolute center_horizontal is-align-items-center">
              <div style="width: 40px; height: 30px" class="margin-right">
                <WhatsAppLink :phoneNumber="applicant_data.phone_number" :message="offers_helper.outSourceTemplate(whatsappParams, whatsappTemplate)"></WhatsAppLink>
              </div>
              <link-entity :payload="applicant_data"></link-entity>
              <timer v-model="timer"></timer>
              <div class="horizontal_space"></div>
              <div class="horizontal_space"></div>
              <div dir="rtl" class="is-flex">
                <location-editor :onSubmit="handleLocation" :payload="{ location: {description: location}, resource_type: 'Applicant', resource_id: applicant_data.resource_id }"></location-editor>
              </div>
              <div class="horizontal_space"></div>
              <p>|</p>
              <div class="horizontal_space"></div>
              <div class="horizontal_space"></div>
              <a @click="openSkills" class="button is-outlined is-info">Skills</a>
              <div class="horizontal_space"></div>
              <a @click="createEducation" class="button is-outlined is-info">Create Education</a>
              <div class="horizontal_space"></div>
              <a @click="createHistoryCompany" class="button is-outlined is-info">Create History Company</a>
              <div class="horizontal_space"></div>
              <div class="horizontal_space"></div>
              <ghana-flag :payload="applicant_data" :eager_load="true" target="_blank"></ghana-flag>
            </div>
            <a v-if="show_generate_offers" @click="generateOffers" class="button is-info generate_offers">Generate Offers</a>
            <router-link v-if="show_offers_link" :to="{ name: 'applicant-offers', query: { applicant_id: applicant_data.resource_id, statuses: 'awaiting_company,system_strong', sort: '-sent_at', is_hot_positions: 'true' } }" target="_blank" class="button is-outlined is-info">
              Show Offers
            </router-link>
          </div>
        </div>
        <applicant-cv-pdf :payload="applicant_data" class="applicant_cv_pdf applicant_profile_html_container"></applicant-cv-pdf>
      </div>
      <p v-else class="bold">הבקשות נשלחו בהצלחה. אפשר לסגור את החלון.</p>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import AttributeDisplay from '@/components/AttributeDisplay'
import TextsHelper from '@/custom/classes/texts_helper.js'
import QuestionsHelper from '@/custom/classes/questions_helper.js'
import Checkbox from '@/components/Checkbox'
import QSelect from '@/components/QSelect'
import SkillsForm from '@/components/SkillsForm.vue'
import Timer from '@/components/Timer'
import ApplicantCvPdf from '@/components/ApplicantCvPdf'
import LinkEntity from '@/components/LinkEntity'
import LocationEditor from '@/components/LocationEditor'
import GhanaFlag from '@/components/GhanaFlag'
import VettingRecipeSelector from '@/components/VettingRecipeSelector'
import OffersHelper from '@/custom/classes/offers_helper'
import { getOwner } from '@/custom/classes/my_utils.js'
import WhatsAppLink from './WhatsAppLink.vue'
import Status from '@/components/entities/applicant/Status'
import Abstract from './entities/applicant/Abstract.vue'

export default {
  props: ['payload'],
  name: 'vetting-form',
  data () {
    return {
      applicant_data: undefined,
      location: undefined,
      is_submitted: false,
      is_populating_recipe: false,
      show_generate_offers: true,
      show_offers_link: false,
      texts_helper: new TextsHelper(),
      questions_helper: new QuestionsHelper(),
      offers_helper: new OffersHelper(),
      is_loading: false,
      is_star: -1,
      is_watch: false,
      questions: [],
      questions_data: {},
      abstract: '',
      salary_expectations_comment: '',
      job_description: '',
      preferred_work_region: '',
      certification_date: false,
      referral_text: '',
      timer: '00:00',
      internal_notes: '',
      applicant_status: '',
      status: 'active',
      message: '',
      tags: '',
      profile_html: '',
      is_discrete_answered: false,
      job_title_answered: false,
      approve_email_truthy: false,
      eleven_months_alert: false
    }
  },
  created () {
    this.$network_utils.getApplicant({ id: this.payload.applicant_id }).then(response => {
      this.applicant_data = response
      if (response.certification_date) {
        this.certification_date = true
      }
      this.location = response.location
      this.message = response.message
      this.abstract = response.abstract
      this.preferred_work_region = response.preferred_work_region
      this.applicant_status = response.applicant_status
      this.init()
    })
  },
  watch: {
    abstract () {
      localStorage.setItem('vetting_abstract_temp_text', this.abstract)
    },
    internal_notes () {
      localStorage.setItem('vetting_internal_notes_temp_text', this.internal_notes)
    }
  },
  computed: {
    seniorityYears () {
      return this.$moment().diff(this.applicant_data.certification_date, 'years')
    },
    certificationDateFormat () {
      return this.$moment(this.applicant_data.certification_date).format('MM/YYYY')
    },
    getSelectedIsStarImg () {
      if (this.is_star == 1) {
        return '/is_star_full.png'
      }
      if (this.is_star == 0) {
        return '/is_star_purple.png'
      }
      return '/is_star_not_full.png'
    },
    isSubmitButtonEnabled () {
      if (this.isJobTitleMandatory && this.job_title_answered == false) {
        return false
      }
      return this.is_discrete_answered == true
    },
    isJobTitleMandatory () {
      return this.$settings.get({ path: 'vetting_modal' }).is_job_title_mandatory == true
    },
    whatsappTemplate () {
      const env = this.$settings.get({ path: 'operation_name' })
      switch (env) {
        case 'Rebase':
          return 'rebaseVettingMessage'
        case 'Piola':
          return 'piolaVettingMessage'
        case 'Suitup':
        default:
          return 'suitupVettingMessage'
      }
    },
    whatsappParams () {
      return { admin: getOwner().name, applicant: this.applicant_data.first_name }
    }
  },
  methods: {
    handleLocation (data) {
      this.location = data
    },
    certificationDateUpdate (value) {
      const date = this.$moment(value.split('/').reduce((prev, curr) => curr + '-' + prev, '1')).format('YYYY-MM-DD')
      this.applicant_data.certification_date = date
      this.certification_date = true
    },
    openSkills () {
      let applicant_name = this.applicant_data.first_name + ' ' + this.applicant_data.last_name
      this.create({
        designator: 'applicant-skill-form-modal',
        component_name: 'ApplicantSkillsForm',
        data: this.applicant_data,
        modal_title: applicant_name + ' Skills',
        modal_width: 1300,
        is_center_modal: true
      })
    },
    setTags (value) {
      this.tags = value
    },
    questionValueSelected (answer_data) {
      this.questions_data[answer_data.question.designator] = answer_data
      if (answer_data.question.designator == 'is_discrete') {
        this.is_discrete_answered = answer_data.value.length > 0
      }
      if (answer_data.question.designator == 'job_title') {
        this.job_title_answered = answer_data.value.length > 0
      }
      if (answer_data.question.designator == 'approve_email') {
        this.approve_email_truthy = answer_data.text == 'TRUE'
      }
    },
    answerQuestion (params) {
      return this.$network_utils.postQuestionAnswer({
        question_id: params.question_id,
        option_ids: params.option_ids,
        designator: params.designator,
        current_resource_id: this.applicant_data.resource_id,
        current_type: 'Applicant'
      })
    },
    answerQuestions () {
      let requests = []
      for (let designator in this.questions_data) {
        let answer_data = this.questions_data[designator]
        requests.push(
          this.answerQuestion({
            question_id: answer_data.question.id,
            option_ids: answer_data.value,
            designator: designator
          })
        )
      }
      return requests
    },
    preSubmit () {
      if (this.eleven_months_alert) {
        this.$network_utils.postAlert({
          designator: 'missions',
          content: 'ליצור קשר עוד 11 חודשים',
          status: 'active',
          priority: 90,
          resource_type: 'Applicant',
          resource_id: this.payload.applicant_id,
          timing: this.$moment().add(11, 'months')
        })
      }
      this.submit()
    },
    submit () {
      if (!this.location) {
        this.$utils.emit('show_toast', { text: 'Please enter location' })
        return
      }
      if (!this.preferred_work_region) {
        this.$utils.emit('show_toast', { text: 'Please enter preferred work region' })
        return
      }
      if (this.$settings.get({ path: 'operation_name' }) == 'Suitup' && !this.certification_date) {
        this.$utils.emit('show_toast', { text: 'Please enter certification_date' })
        return
      }
      if (!this.certification_date) {
        this.$utils.emit('show_toast', { text: 'Please enter certification date' })
        return
      }
      if (this.hasBoldProblems()) {
        return
      }
      let requests = [
        this.sendEvents(),
        this.answerQuestions(),
        ...this.answerUser(),
        ...this.answerTexts(),
        ...this.answerStats()
      ]
      this.is_loading = true
      this.$caller.axios.all(requests).then(() => {
        this.is_submitted = true
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'success' })
        this.remove(this.payload)
      }).catch(() => {
        this.$utils.emit('show_toast', { text: 'ארעה תקלה באימות המועמד, יש לפנות לתמיכה.' })
      })
    },
    generateOffers (user_response) {
      this.$network_utils.updateUser({
        user_id: this.applicant_data.id,
        status: 'active'
      }).then(() => {
        this.$network_utils.postEvent({ current_type: 'Applicant', current_resource_id: this.applicant_data.resource_id, statuses: 'awaiting_applicant,preview', event: 'resource_updated', sidekiq_queue: 'high' })
        this.show_generate_offers = false
        this.show_offers_link = true
      })
    },
    sendEvents () {
      return this.$network_utils.postEvent({
        event: 'applicant_vetted',
        current_type: 'Applicant',
        current_resource_id: this.applicant_data.resource_id
      })
    },
    answerUser () {
      let requests = []
      requests.push(this.$network_utils.updateApplicant({
        applicant_id: this.applicant_data.resource_id,
        is_star: this.is_star,
        is_watch: this.is_watch,
        salary_expectations_comment: this.salary_expectations_comment,
        preferred_work_region: this.preferred_work_region
      }))
      requests.push(this.$network_utils.updateUser({
        user_id: this.applicant_data.id,
        status: this.status,
        message: this.message,
        tags: this.tags,
        owner: this.$utils.getOwner().name
      }))
      return requests
    },
    appendTimer () {
      return '\n' + 'זמן שיחה: ' + this.timer
    },
    hasBoldProblems () {
      return this.getBoldInternalNotes() == 'problem' || this.getBoldAbstract() == 'problem'
    },
    getBoldInternalNotes () {
      return this.texts_helper.getBoldContent(this.internal_notes + this.appendTimer(), 'internal_notes')
    },
    getBoldAbstract () {
      return this.texts_helper.getBoldContent(this.abstract, 'abstract')
    },
    answerStats () {
      let requests = []
      let internal_notes_content = this.getBoldInternalNotes()
      let abstract_content = this.getBoldAbstract()
      requests.push(this.$network_utils.postStat({
        designator: 'internal_notes',
        status: 'done',
        title: 'אימות מועמד',
        owner: this.$utils.getOwner().name,
        content: internal_notes_content,
        priority: 7,
        resource_id: this.applicant_data.resource_id,
        resource_type: 'Applicant'
      }))
      let vetted_stat_content =
        'user is vetted,\n abstract:\n ' +
        abstract_content +
        ', \n internal_notes: \n ' +
        internal_notes_content
      requests.push(this.$network_utils.postStat({
        designator: 'applicant_vetted',
        status: 'done',
        title: 'אימות מועמד',
        owner: this.$utils.getOwner().name,
        content: vetted_stat_content,
        priority: 7,
        resource_id: this.applicant_data.resource_id,
        resource_type: 'Applicant'
      }))
      if (this.applicant_data.message == this.message) {
        return requests
      }
      requests.push(this.$network_utils.postStat({
        title: 'feed_message',
        designator: 'feed_message',
        content: 'Message Changed:<br><b>Old Message was:</b> ' + this.applicant_data.message + '<br><b>New Message is: </b>' + this.message,
        status: 'active',
        owner: this.$utils.getOwner().name,
        priority: 55,
        resource_id: this.applicant_data.resource_id,
        resource_type: 'Applicant'
      }))
      return requests
    },
    answerTexts () {
      let requests = []
      const texts = ['referral_text', 'job_description']
      texts.forEach(text => {
        requests.push(this.$network_utils.postText({
          designator: text,
          content: this[text],
          current_resource_id: this.applicant_data.resource_id,
          current_type: 'Applicant'
        }))
      })
      return requests
    },
    initQuestions () {
      for (let i = 0; i < this.questions.length; i++) {
        let question = this.questions[i]
        this.questions_data[question.designator] = {}
        this.questions_data[question.designator].question = this.questions_helper.getQuestionByDesignator(this.questions, question.designator)
      }
    },
    init () {
      let designators =
        'job_title,interview_score,vetted_by,is_discrete,is_senior,approve_email,arrived_through,gender,certification_date,skip_educations_filter,skip_seniority_filter,' +
        this.$settings.get({ path: 'vetting_modal' }).additional_questions
      this.$network_utils
        .getResourceQuestions({
          current_type: 'Applicant',
          current_resource_id: this.applicant_data.resource_id,
          designators: designators
        })
        .then(response => {
          this.questions = this.getQuestionsWithSortedOptions(response)
          this.initQuestions()
        })
    },
    createEducation () {
      this.create({
        designator: 'applicant-educations-form-modal',
        component_name: 'ApplicantEducationsForm',
        is_create: true,
        applicant_id: this.applicant_data.resource_id,
        modal_title: 'Create new Education'
      })
    },
    createHistoryCompany () {
      this.create({
        designator: 'applicant-history-companies-form-modal',
        component_name: 'ApplicantHistoryCompaniesForm',
        is_create: true,
        applicant_id: this.applicant_data.resource_id,
        modal_title: 'Create new History Company'
      })
    },
    getQuestionsWithSortedOptions (questions) {
      return questions.map(question => {
        question.options.sort((a, b) => b.option_order - a.option_order)
        return question
      })
    },
    ...mapMutations('modals', ['create', 'remove', 'removeModalById'])
  },
  components: {
    Checkbox,
    QSelect,
    Timer,
    LinkEntity,
    Status,
    Abstract,
    ApplicantCvPdf,
    LocationEditor,
    SkillsForm,
    GhanaFlag,
    VettingRecipeSelector,
    AttributeDisplay,
    WhatsAppLink
  }
}
</script>
<style scoped>
  .error{
    border-color: red !important;
  }
  .applicant_profile_html_container{
    min-height: 100%;
    border-right: 2px solid rgba(0, 0, 0, 0.3);
    padding-right: 30px;
    margin-right: 30px;
  }
  .questions {
    padding-right: 10px;
  }
  .q_select{
    margin-bottom: 10px !important;
  }
  .vetting_modal_content{
    text-align: right;
    width: 100%;
  }
  .vetting_modal_textarea {
    width: 100%;
    height: 350px;
  }
  .submit_abstract {
    margin-top: 10px;
  }
</style>
